import React from 'react';
import { LiveChatAccountAccess } from '../domain';
import { useUserData, IAccountType } from '@gr/user-context';
import { LivechatPermission } from '../constants';
export const getLiveChatAccountAccess = (permissions) => {
    const canDisplayLiveChat = permissions.includes(LivechatPermission.Livechat);
    const showTransitionScreen = permissions.includes(LivechatPermission.LivechatTransitionScreen);
    if (!canDisplayLiveChat) {
        return LiveChatAccountAccess.Blocked;
    }
    return showTransitionScreen ? LiveChatAccountAccess.GrantedAfterUpgrade : LiveChatAccountAccess.Granted;
};
export const useAccountData = () => {
    const userData = useUserData();
    const account = React.useMemo(() => {
        if (!userData) {
            return;
        }
        const requiredUserData = userData;
        return {
            crypto: requiredUserData.crypto,
            daysToExpiration: requiredUserData.daysToExpiration,
            email: requiredUserData.email,
            firstName: requiredUserData.firstName,
            isCollaborator: requiredUserData.isCollaborator,
            isOwner: requiredUserData.isAccountOwner,
            lastName: requiredUserData.lastName,
            maxOfferSystem: requiredUserData.maxOfferSystem,
            packet: requiredUserData.packet,
            plan: requiredUserData.plan,
            userId: requiredUserData.userIdN,
            collaboratorOwnerEmail: requiredUserData.collaboratorOwnerEmail,
            isFree: requiredUserData.accountType === IAccountType.Free,
            livechatAccess: getLiveChatAccountAccess(requiredUserData.permissions),
        };
    }, [userData]);
    return account;
};
